import { ChangeDetectionStrategy, Component, forwardRef, input } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
    type RisrSchemaDisplayElementInterface,
    type RisrSchemaDisplayGroup,
    type RisrSchemaDisplayArray,
    type RisrSchemaDisplayField,
} from "./risr-schema-display";
import { RisrSchemaDisplayArrayRenderer } from "./risr-schema-display-array-renderer";
import { RisrSchemaDisplayFieldRenderer } from "./risr-schema-display-field-renderer";

@Component({
    selector: 'risr-schema-display-group-renderer',
    imports: [
        CommonModule,
        forwardRef(() => RisrSchemaDisplayFieldRenderer),
        forwardRef(() => RisrSchemaDisplayArrayRenderer)
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if (field().visible()) {
            <div class="display-group">
                @for (child of field().risrElements; track child.name) {
                    @if (isField(child)) {
                        <risr-schema-display-field-renderer [field]="child"></risr-schema-display-field-renderer>
                    }
                    @if (isArray(child)) {
                        <risr-schema-display-array-renderer [field]="child"></risr-schema-display-array-renderer>
                    }
                    @if (isGroup(child)) {
                        <risr-schema-display-group-renderer [field]="child"></risr-schema-display-group-renderer>
                    }
                }
            </div>
        }
    `,
    styles: [`
        .display-group {
            display: grid;
            gap: 0.75rem;
        }
    `],
})
export class RisrSchemaDisplayGroupRenderer {
    field = input.required<RisrSchemaDisplayGroup>();

    protected isField(field: RisrSchemaDisplayElementInterface): field is RisrSchemaDisplayField {
        return field.type === 'field';
    }

    protected isArray(field: RisrSchemaDisplayElementInterface): field is RisrSchemaDisplayArray {
        return field.type === 'array';
    }

    protected isGroup(field: RisrSchemaDisplayElementInterface): field is RisrSchemaDisplayGroup {
        return field.type === 'group';
    }
}
